import storage from './storage';

const MAX_ENTRIES = 200;

function key(userId) {
  return userId ? `crm_notifs_u${userId}` : 'crm_notifs';
}

export const notificationService = {
  getAll(userId) {
    return storage.get(key(userId), []);
  },

  saveAll(userId, notifs) {
    storage.set(key(userId), notifs.slice(0, MAX_ENTRIES));
  },
};
